import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { configLoader } from "@/config";
import useFeatureFlagsStore from "@/stores/useFeatureFlagsStore";
import "./index.css";

async function bootstrap() {
  try {
    const config = await configLoader.loadConfig();
    console.log("Config loaded successfully");

    if (config.featureFlags) {
      useFeatureFlagsStore.getState().initializeFromConfig(config.featureFlags);
    }

    const root = createRoot(document.getElementById("root")!);
    root.render(<App config={config} />);
  } catch (error) {
    console.error("Failed to bootstrap application:", error);

    const rootElement = document.getElementById("root");

    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; text-align: center; color: red; font-family: Arial, sans-serif;">
          <h2>Configuration Error</h2>
          <p>Failed to load application configuration. Please check that config.json exists and is valid.</p>
          <details>
            <summary>Error details</summary>
            <pre style="text-align: left; background: #f5f5f5; padding: 10px; margin: 10px 0;">${error instanceof Error ? error.message : String(error)}</pre>
          </details>
        </div>
      `;
    }
  }
}

bootstrap();
